export const UNAVAILABLE = 0;
export const AVAILABLE = 1;
export const MBOX_SHOWN = 2;
export const SELL_REQUESTED = 3;
export const SUCCESS = 4;
export const REJECTED = 5;
export const AMOUNT_CHANGED = 6;



// WEBPACK FOOTER //
// ./js/constants/CashoutStatus.js